import React, {FC} from "react";
import { useTranslation } from "next-i18next";
import {Box} from "@mui/material";


interface FormattedCertificationProps {
  certBody?:string;
  certLevel: string;
}

export const FormattedCertification:FC<FormattedCertificationProps> = ({certBody, certLevel}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{
      backgroundColor: "#636363",
      color: "#fff",
      display: "block",
      padding: "4px 6px",
      textAlign: "center",
      fontWeight: 500}}>
      {!!certBody && `${certBody} - `} {!!certLevel && certLevel}
      {!certBody && !certLevel && t('uknown-certification')}
    </Box>
  );
}
